import React from "react";
import { Spin } from "antd";

const Spinner = () => {
  return (
    <div className="full-page-spin">
      <Spin size="large" />
    </div>
  );
};

export default Spinner;
